import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Building2, Users, TrendingUp, MapPin, Phone, Mail, ArrowRight, Star, Factory, Store, Landmark, Globe, Handshake, Target, Award, CheckCircle } from "lucide-react";
const Index = () => {
  const services = [{
    icon: Building2,
    title: "Office, Industrial, MultiFamily and Retail",
    description: "Comprehensive commercial real estate services across office, industrial, multifamily, and retail properties with flexible terms and competitive rates."
  }, {
    icon: TrendingUp,
    title: "Investment Sales",
    description: "Strategic investment opportunities with comprehensive market analysis and due diligence."
  }, {
    icon: Users,
    title: "Tenant Representation",
    description: "Expert representation to secure the perfect space that meets your business requirements."
  }, {
    icon: MapPin,
    title: "Market Analysis",
    description: "In-depth market research and analysis to inform your commercial real estate decisions."
  }];
  return <div className="min-h-screen bg-background">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <img src="./images/KWCommercial_Stacked_RGB.png" alt="KW Commercial" className="h-12 w-auto" />
            </div>
            
            <Button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 btn-primary bg-[rgb(221,25,14)]">
              Get Started
            </Button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative h-[600px] flex items-center justify-center">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1767176736287-eb90b3c1fc61?w=1440&auto=format&fit=crop&q=80')`
      }}>
          <div className="absolute inset-0 hero-gradient"></div>
        </div>
        <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Premier Commercial
            <span className="block text-[rgb(0,0,0)]">Real Estate Solutions</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-white/90">Your trusted partner for leasing, investment sales, and tenant representation in today's dynamic commercial real estate market.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            
            
          </div>
        </div>
      </section>

      {/* About Angel Cazares Section */}
      <section id="about" className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6">About Angel Cazares</h2>
              <p className="text-lg text-muted-foreground mb-6">
                As a licensed commercial real estate agent based in El Paso and proudly affiliated with KW Commercial, 
                Angel Cazares transforms property challenges into opportunities. His focus is helping business owners, 
                investors, and property owners create lasting value.
              </p>
              <p className="text-lg text-muted-foreground mb-6">
                This applies whether clients are searching for their first retail storefront or expanding their 
                portfolio with a major acquisition.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-primary mr-3" />
                  <span>Licensed Commercial Agent</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-primary mr-3" />
                  <span>KW Commercial Affiliated</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-primary mr-3" />
                  <span>El Paso Market Expert</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-primary mr-3" />
                  <span>Bilingual (English & Spanish)</span>
                </div>
              </div>
              <Button className="btn-primary">
                Contact Us (915) 242-5442 <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>
            <div className="relative">
              <img src="./images/Untitled design.jpg" alt="Angel Cazares - Commercial Real Estate Agent" className="rounded-lg shadow-elegant w-full max-w-md mx-auto" />
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-card">
                <div className="text-center">
                  <p className="font-semibold text-primary">Angel Cazares</p>
                  <p className="text-sm text-muted-foreground">KW Commercial</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-secondary/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Angel's Expertise & Services</h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Angel brings deep knowledge of El Paso's commercial landscape to every client relationship. 
              His specialties include tenant representation, investment sales, and commercial leasing.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => {
            const Icon = service.icon;
            return <Card key={index} className="shadow-card hover:shadow-hover transition-smooth">
                  <CardHeader className="text-center">
                    <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                      <Icon className="h-8 w-8 text-primary" />
                    </div>
                    <CardTitle className="text-xl">{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-center">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </section>

      {/* Why Work With Us Section */}
      <section className="py-20 bg-secondary/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-6">Why Work With Us</h2>
            <p className="text-xl text-muted-foreground max-w-4xl mx-auto leading-relaxed">
              In commercial real estate, experience, strategy, and advocacy matter. We provide focused, 
              client-first representation designed to protect your interests and maximize value at every 
              stage of the transaction.
            </p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h3 className="text-2xl font-bold mb-6">Our Approach</h3>
              <p className="text-lg text-muted-foreground mb-6">
                Our approach is rooted in market knowledge, disciplined analysis, and clear execution—so 
                you can move forward with confidence. We take the time to understand your business objectives 
                and tailor strategies that align with your short- and long-term goals.
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-primary mr-3 mt-1" />
                  <div>
                    <span className="font-semibold">Data-Driven Decisions:</span>
                    <span className="text-muted-foreground ml-2">Every recommendation backed by market data and analysis</span>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-primary mr-3 mt-1" />
                  <div>
                    <span className="font-semibold">Strategic Planning:</span>
                    <span className="text-muted-foreground ml-2">Tailored strategies for your short and long-term goals</span>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-primary mr-3 mt-1" />
                  <div>
                    <span className="font-semibold">Market Knowledge:</span>
                    <span className="text-muted-foreground ml-2">Deep understanding of El Paso's commercial landscape</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-bold mb-6">Full-Service Expertise</h3>
              <p className="text-lg text-muted-foreground mb-6">
                From site selection and lease negotiations to acquisitions and dispositions, every 
                recommendation is backed by data, insight, and experience.
              </p>
              <div className="grid grid-cols-2 gap-4">
                <Card className="shadow-card">
                  <CardHeader className="pb-3">
                    <CardTitle className="text-base">Site Selection</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground">
                      Strategic location analysis for optimal positioning
                    </p>
                  </CardContent>
                </Card>
                
                <Card className="shadow-card">
                  <CardHeader className="pb-3">
                    <CardTitle className="text-base">Lease Negotiations</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground">
                      Protecting your interests in every agreement
                    </p>
                  </CardContent>
                </Card>
                
                <Card className="shadow-card">
                  <CardHeader className="pb-3">
                    <CardTitle className="text-base">Acquisitions</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground">
                      Investment opportunities with strong ROI potential
                    </p>
                  </CardContent>
                </Card>
                
                <Card className="shadow-card">
                  <CardHeader className="pb-3">
                    <CardTitle className="text-base">Dispositions</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground">
                      Maximizing value when selling your properties
                    </p>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg p-8 shadow-card">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold mb-4">Transparency & Communication</h3>
              <p className="text-lg text-muted-foreground max-w-4xl mx-auto">
                Transparency and communication are central to how we operate. You'll receive clear guidance, 
                timely updates, and honest advice—without pressure or surprises.
              </p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Target className="h-8 w-8 text-primary" />
                </div>
                <h4 className="font-semibold mb-2">Clear Guidance</h4>
                <p className="text-sm text-muted-foreground">
                  Straightforward advice to help you make informed decisions
                </p>
              </div>
              
              <div>
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Globe className="h-8 w-8 text-primary" />
                </div>
                <h4 className="font-semibold mb-2">Timely Updates</h4>
                <p className="text-sm text-muted-foreground">
                  Regular communication throughout every transaction
                </p>
              </div>
              
              <div>
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Handshake className="h-8 w-8 text-primary" />
                </div>
                <h4 className="font-semibold mb-2">Long-term Partnership</h4>
                <p className="text-sm text-muted-foreground">
                  Building relationships as your trusted commercial real estate advisor
                </p>
              </div>
            </div>
            
            <div className="text-center mt-8">
              <p className="text-lg text-muted-foreground italic">
                "Our objective is not simply to complete transactions, but to build long-term relationships 
                and serve as a trusted commercial real estate advisor for years to come."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Asset Types Section */}
      <section id="asset-types" className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Commercial Asset Types</h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Angel specializes in five key commercial real estate asset types in El Paso: 
              Industrial, Office, Land, Retail, and Multi Family properties.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
            <Card className="shadow-card hover:shadow-hover transition-smooth text-center">
              <CardHeader>
                <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                  <Building2 className="h-8 w-8 text-primary" />
                </div>
                <CardTitle className="text-xl">Office</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="mb-4">
                  Professional office spaces for businesses of all sizes
                </CardDescription>
                <ul className="text-sm text-left space-y-1">
                  <li>• Executive suites</li>
                  <li>• Medical offices</li>
                  <li>• Co-working spaces</li>
                  <li>• Corporate headquarters</li>
                </ul>
              </CardContent>
            </Card>
            
            <Card className="shadow-card hover:shadow-hover transition-smooth text-center">
              <CardHeader>
                <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                  <Store className="h-8 w-8 text-primary" />
                </div>
                <CardTitle className="text-xl">Retail</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="mb-4">
                  High-visibility retail locations for maximum customer exposure
                </CardDescription>
                <ul className="text-sm text-left space-y-1">
                  <li>• Strip centers</li>
                  <li>• Restaurant locations</li>
                  <li>• Standalone retail</li>
                  <li>• Shopping plazas</li>
                </ul>
              </CardContent>
            </Card>
            
            <Card className="shadow-card hover:shadow-hover transition-smooth text-center">
              <CardHeader>
                <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                  <Factory className="h-8 w-8 text-primary" />
                </div>
                <CardTitle className="text-xl">Industrial</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="mb-4">
                  Warehouse, manufacturing, and distribution facilities
                </CardDescription>
                <ul className="text-sm text-left space-y-1">
                  <li>• Warehouses</li>
                  <li>• Manufacturing</li>
                  <li>• Distribution centers</li>
                  <li>• Flex space</li>
                </ul>
              </CardContent>
            </Card>
            
            <Card className="shadow-card hover:shadow-hover transition-smooth text-center">
              <CardHeader>
                <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                  <Landmark className="h-8 w-8 text-primary" />
                </div>
                <CardTitle className="text-xl">Land</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="mb-4">
                  Development opportunities and investment land parcels
                </CardDescription>
                <ul className="text-sm text-left space-y-1">
                  <li>• Development sites</li>
                  <li>• Investment parcels</li>
                  <li>• Mixed-use opportunities</li>
                  <li>• Build-to-suit land</li>
                </ul>
              </CardContent>
            </Card>
            
            <Card className="shadow-card hover:shadow-hover transition-smooth text-center">
              <CardHeader>
                <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                  <Users className="h-8 w-8 text-primary" />
                </div>
                <CardTitle className="text-xl">Multi Family</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="mb-4">
                  Apartment complexes and multi-unit residential investments
                </CardDescription>
                <ul className="text-sm text-left space-y-1">
                  <li>• Apartment complexes</li>
                  <li>• Duplex & fourplex</li>
                  <li>• Student housing</li>
                  <li>• Senior living</li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Angel's Approach & Clients Section */}
      <section className="py-20 bg-secondary/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">A Strategic, Client-Focused Approach</h2>
            <p className="text-xl text-muted-foreground max-w-4xl mx-auto">
              Angel believes that great business is built on trust, education, and partnership. His role is not just 
              to broker deals but to be a long-term advisor and advocate for clients.
            </p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12 mb-16">
            <div>
              <h3 className="text-2xl font-bold mb-6">Angel's Process</h3>
              <p className="text-lg text-muted-foreground mb-6">
                Angel's approach is hands-on and proactive. He guides clients through every phase of the 
                commercial real estate process, from property identification through closing.
              </p>
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center mr-4 text-sm font-semibold">1</div>
                  <span>Property identification and market analysis</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center mr-4 text-sm font-semibold">2</div>
                  <span>Due diligence and property evaluation</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center mr-4 text-sm font-semibold">3</div>
                  <span>Strategic negotiation and deal structuring</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center mr-4 text-sm font-semibold">4</div>
                  <span>Transaction management through closing</span>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-bold mb-6">Key Strengths</h3>
              <div className="grid grid-cols-1 gap-4">
                <Card className="shadow-card">
                  <CardHeader className="pb-3">
                    <div className="flex items-center">
                      <Target className="h-6 w-6 text-primary mr-3" />
                      <CardTitle className="text-lg">Strategic Focus</CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground">
                      Every transaction is approached with strategy and integrity, structuring creative solutions when needed.
                    </p>
                  </CardContent>
                </Card>
                
                <Card className="shadow-card">
                  <CardHeader className="pb-3">
                    <div className="flex items-center">
                      <Globe className="h-6 w-6 text-primary mr-3" />
                      <CardTitle className="text-lg">Bilingual Service</CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground">
                      Fluent in English and Spanish, serving El Paso's diverse business community effectively.
                    </p>
                  </CardContent>
                </Card>
                
                <Card className="shadow-card">
                  <CardHeader className="pb-3">
                    <div className="flex items-center">
                      <Award className="h-6 w-6 text-primary mr-3" />
                      <CardTitle className="text-lg">Client Education</CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground">
                      Empowering clients to make confident, informed decisions by ensuring they understand all options.
                    </p>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
          
          {/* Client Types */}
          <div className="text-center mb-12">
            <h3 className="text-2xl font-bold mb-4">Diverse Client Base in El Paso</h3>
            <p className="text-lg text-muted-foreground mb-8">
              Angel serves a wide range of clients across El Paso's business community
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card className="shadow-card text-center">
              <CardHeader>
                <CardTitle className="text-lg text-primary">Office Properties</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Professional office spaces, corporate headquarters, and business centers
                </p>
              </CardContent>
            </Card>
            
            <Card className="shadow-card text-center">
              <CardHeader>
                <CardTitle className="text-lg text-primary">Industrial Properties</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Warehouses, manufacturing facilities, and distribution centers
                </p>
              </CardContent>
            </Card>
            
            <Card className="shadow-card text-center">
              <CardHeader>
                <CardTitle className="text-lg text-primary">Medical Office</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Specialized medical office spaces for healthcare professionals
                </p>
              </CardContent>
            </Card>
            
            <Card className="shadow-card text-center">
              <CardHeader>
                <CardTitle className="text-lg text-primary">Retail Properties</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Shopping centers, restaurants, and high-visibility retail locations
                </p>
              </CardContent>
            </Card>
            
            <Card className="shadow-card text-center">
              <CardHeader>
                <CardTitle className="text-lg text-primary">Land Development</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Development sites, investment parcels, and build-to-suit opportunities
                </p>
              </CardContent>
            </Card>
            
            <Card className="shadow-card text-center">
              <CardHeader>
                <CardTitle className="text-lg text-primary">Multi Family Properties</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Apartment complexes and multi-unit residential investment opportunities
                </p>
              </CardContent>
            </Card>
            
            <Card className="shadow-card text-center">
              <CardHeader>
                <CardTitle className="text-lg text-primary">Investment Properties</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Income-producing properties with strong ROI potential across all sectors
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Contact Angel Cazares</h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Ready to discuss your commercial real estate needs in El Paso? Contact Angel today for a consultation.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <Card className="shadow-card">
              <CardHeader>
                <Phone className="h-8 w-8 text-primary mx-auto mb-4" />
                <CardTitle>Call Us</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-4">Speak with our experts</p>
                <p className="text-lg font-semibold">(915) 242-5441</p>
              </CardContent>
            </Card>
            <Card className="shadow-card">
              <CardHeader>
                <Mail className="h-8 w-8 text-primary mx-auto mb-4" />
                <CardTitle>Email Us</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-4">Send us a message</p>
                <p className="text-lg font-semibold">Angelcazares@kw.com</p>
              </CardContent>
            </Card>
            <Card className="shadow-card">
              <CardHeader>
                <MapPin className="h-8 w-8 text-primary mx-auto mb-4" />
                <CardTitle>Visit Us</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-4">Our office location</p>
                <p className="text-lg font-semibold">5822 Cromo Dr. STE 205, El Paso, TX 79912</p>
              </CardContent>
            </Card>
          </div>
          <div className="text-center mt-12">
            <Button size="lg" className="btn-primary px-8">
              Contact Us
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-foreground text-background py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <img src="./images/KWCommercial_Stacked_RGB.png" alt="KW Commercial" className="h-12 w-auto mb-4" />
              <p className="text-background/80">
                Your trusted partner in commercial real estate.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Services</h4>
              <ul className="space-y-2 text-background/80">
                <li>Office Leasing</li>
                <li>Investment Sales</li>
                <li>Tenant Representation</li>
                <li>Market Analysis</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Properties</h4>
              <ul className="space-y-2 text-background/80">
                <li>Office Buildings</li>
                <li>Retail Centers</li>
                <li>Industrial Warehouses</li>
                <li>Mixed-Use Developments</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Contact Angel</h4>
              <ul className="space-y-2 text-background/80">
                <li>(915) 242-5441</li>
                <li>Angelcazares@kw.com</li>
                <li>5822 Cromo Dr. STE 205</li>
                <li>El Paso, TX 79912</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-background/20 mt-8 pt-8 text-center text-background/60">
            <p>&copy; 2024 KW Commercial. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
};
export default Index;